import { render, staticRenderFns } from "./PreorderProducts.vue?vue&type=template&id=5228b23a&scoped=true&"
import script from "./PreorderProducts.vue?vue&type=script&lang=js&"
export * from "./PreorderProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5228b23a",
  null
  
)

export default component.exports